var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainprof(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 37.5C42.4728 37.5 47.2419 35.5246 50.7583 32.0083C54.2746 28.4919 56.25 23.7228 56.25 18.75C56.25 13.7772 54.2746 9.00806 50.7583 5.49175C47.2419 1.97544 42.4728 0 37.5 0C32.5272 0 27.7581 1.97544 24.2417 5.49175C20.7254 9.00806 18.75 13.7772 18.75 18.75C18.75 23.7228 20.7254 28.4919 24.2417 32.0083C27.7581 35.5246 32.5272 37.5 37.5 37.5ZM50 18.75C50 22.0652 48.683 25.2446 46.3388 27.5888C43.9946 29.933 40.8152 31.25 37.5 31.25C34.1848 31.25 31.0054 29.933 28.6612 27.5888C26.317 25.2446 25 22.0652 25 18.75C25 15.4348 26.317 12.2554 28.6612 9.91116C31.0054 7.56696 34.1848 6.25 37.5 6.25C40.8152 6.25 43.9946 7.56696 46.3388 9.91116C48.683 12.2554 50 15.4348 50 18.75ZM75 68.75C75 75 68.75 75 68.75 75H6.25C6.25 75 0 75 0 68.75C0 62.5 6.25 43.75 37.5 43.75C68.75 43.75 75 62.5 75 68.75ZM68.75 68.725C68.7437 67.1875 67.7875 62.5625 63.55 58.325C59.475 54.25 51.8063 50 37.5 50C23.1937 50 15.525 54.25 11.45 58.325C7.2125 62.5625 6.2625 67.1875 6.25 68.725H68.75Z",
    fill: "#006CE4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainprof);
export default __webpack_public_path__ + "static/media/mainprof.27a19571af1249db50944c1132b24d66.svg";
export { ForwardRef as ReactComponent };